import { AccountType } from "@/enums/account-type";
import { mapGetters, mapState } from "vuex";

export const companyMember = {
  computed: {
    ...mapState({
      company: state => state.company.company,
      member: state => state.permissions.member,
      permissions: state => state.permissions.member.permissions,
      mode: state => state.permissions.mode
    }),
    ...mapGetters({
      editMode: "permissions/editMode",
      previewMode: "permissions/previewMode"
    }),
    accountType: {
      get() {
        return this.$store.state.permissions.member.type;
      },
      set(type) {
        this.$store.dispatch("permissions/setAccountType", type);
      }
    },
    email: {
      get() {
        return this.$store.state.permissions.member.email;
      },
      set(email) {
        this.$store.commit("permissions/SET_EMAIL", email);
      }
    },
    isOwner() {
      return this.accountType === this.accountTypes.OWNER;
    },
    isAdmin() {
      return this.accountType === this.accountTypes.ADMIN;
    },
    isManager() {
      return this.accountType === this.accountTypes.MANAGER;
    }
  },
  data() {
    return {
      accountTypes: AccountType
    };
  },
  methods: {
    setActiveDialog(type, mode = null) {
      this.$store.dispatch("permissions/setActiveDialog", { type, mode });
    },
    closeDialog() {
      this.$store.dispatch("permissions/setActiveDialog", { type: null });
    }
  }
};
